import React from 'react'
import { CourtImageSlider } from '../AllSliders/CourtImageSlider'
import { SliderAboutBookReview } from '../AllSliders/SliderAboutBookReview'
import map from '../assets/map.png'
import offer from '../assets/offer.png'
import Modal from '../Modal'
const AboutComp = () => {
  return (
    <>
    <div className='about-main-bg mt-5'>
    <div className='about-bg-wrap md:h-[20rem] w-[92%] mx-auto h-[10rem] rounded-xl'>

    </div>
    </div>

    <div className='md:w-[80%]   -mt-[3rem]   mx-auto'>

<div className='rounded-full border-4 ml-3 border-gray-200 h-[5rem] w-[5rem]'>
        <img src={offer} alt='img' className='w-full ' />
</div>
</div>




    <div className='md:w-[75%] mt-5  mx-auto'>

                        <div className=' mx-3 md:flex'>
                                 

                                 {/* book court left */}

                            <div className='book-court-left order-1 md:w-[60%]'>
                                <div>
                                    <div>
                                        <h1 className='text-[18px] text-[#272C34] font-bold'>Padel co.ltd</h1>
                                        <p className='text-gray-400 leading-[16px] text-[12px] text-[#6A7D95;]'>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pharetra ornare tempus ipsum, convallis ac tristique. Nunc at arcu volutpat velit. Donec diam ante molestie tempor blandit tellus, orci rhoncus. Quisque ornare morbi ridiculus ante vitae et mattis. </p>
                                    </div>
                                    {/* offer  */}
                                    {/* <div>
                                        <h1 className='text-[18px] text-[#272C34] font-bold py-4'>Offered by</h1>
                                        <div className='flex justify-between border border-gray-300 rounded-xl py-8 px-6'>
                                            <div className='flex'>
                                                <img src={offer} alt='im' />
                                                <h1 className='px-3 pt-5 text-[18px] text-[#272C34] font-bold'>Padel co.ltd</h1>
                                            </div>
                                            <div>
                                                <p className='text-[12px] text-[#409BF5] font-bold pt-5 cursor-pointer'>view company</p>
                                            </div>
                                        </div>
                                    </div> */}

                                    <CourtImageSlider/> 

                                    {/* location   */}
                                    <div>
                                        <h1 className='text-[18px] text-[#272C34] font-bold py-4'>Location (Head office)</h1>
                                        <div className=' border border-gray-300 rounded-xl  '>
                                            <img src={map} alt='img' className='w-full' />
                                        </div>
                                    </div>

                                    {/* service */}
                 

                                    {/* thought  */}
                                    <div>
                                        <h1 className='text-[18px] text-[#272C34] font-bold py-6'>Thoughts about the court</h1>
                                        <div className='flex bg-[#f4f8fa] rounded-xl py-3 md:px-6 px-3'>
                                            <div className=' md:w-[40%] w-[60%]  py-3'>

                                                <h1 className='  pt-3 font-bold text-[26px] text-gray-600'>5/5</h1>

                                                <form className='my-3 mx-auto'>

                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>

                                                </form>

                                                <p className='text-gray-400 text-sm'>14 Ratnings</p>
                                            </div>
                                            <div className='w-full md:ml-32'>


                                                <div className='flex w-full py-1'>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <div className='  md:w-[40%] w-[80%] '>
                                                        <div class=" flex bg-gray-200 mx-4 mt-3 rounded-full  dark:bg-gray-700">
                                                            <div class="bg-blue-600 h-[3px] rounded-full w-[100%]">  </div>
                                                             
                                                        </div>
                                                    </div>
                                                    <p className='text-[12px] text-[#6A7D95]   pt-1 '>14</p>
                                                </div>
                                                <div className='flex w-full py-1'>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <div className=' md:w-[40%] w-[80%]'>
                                                        <div class=" flex bg-gray-400 mx-4 mt-3 rounded-full dark:bg-gray-700">
                                                            <div class="h-[3px] rounded-full  ">  </div>
                                                        </div>
                                                    </div>
                                                    <p className='text-[12px] text-[#6A7D95]     '> </p>
                                                </div>
                                                <div className='flex w-full py-1'>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <div className=' md:w-[40%] w-[80%]'>
                                                        <div class=" bg-gray-400 mx-4 mt-3 rounded-full  dark:bg-gray-700">
                                                            <div class="h-[3px] rounded-full  ">  </div>
                                                        </div>
                                                    </div>
                                                    <p className='text-[12px] text-[#6A7D95]    '> </p>
                                                </div>
                                                <div className='flex w-full py-1'>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <div className=' md:w-[40%] w-[80%]'>
                                                        <div class=" bg-gray-400 mx-4 mt-3 rounded-full dark:bg-gray-700">
                                                            <div class="h-[3px] rounded-full  ">  </div>
                                                        </div>
                                                    </div>
                                                    <p className='text-[12px] text-[#6A7D95]    '> </p>
                                                </div>
                                                <div className='flex w-full py-1'>
                                                    <i class="fa-solid fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <i class="fa-regular fa-star text-base   text-blue-500"></i>
                                                    <div className=' md:w-[40%] w-[80%]'>
                                                        <div class=" bg-gray-400 mx-4 mt-3 rounded-full dark:bg-gray-700">
                                                            <div class="h-[3px] rounded-full  ">  </div>
                                                        </div>
                                                    </div>
                                                    <p className='text-[12px] text-[#6A7D95]    '> </p>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    {/* prefect court management */}

                                    {/* <div className=' '>

                                        <div className=' commentdiv  border-4 my-4 border-gray-300 rounded-xl py-11 px-6'>
                                            <div className=''>
                                                <form className='my-2 mx-auto'>

                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>
                                                    <i class="fa-solid fa-star text-xl   text-blue-500"></i>

                                                </form>
                                                <h1 className='text-[18px] text-[#272C34] font-bold'>Perfect court management</h1>
                                            </div>
                                            <div>
                                                <p className='text-[#272C34]  pt-5 text-[12px]'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                            Vestibulum nunc metus, mattis quis nibh eget, vulputate ultrices est.
                                            Cras ipsum sapien, malesuada nec sagittis id, convallis quis purus.
                                            Cras faucibus risus gravida libero vestibulum, nec viverra risus ultricies.</p>
                                            </div>
                                            <div className=''>
                                                <p className='text-gray-500 float-right italic pt-5 text-sm'>    John Doe</p>
                                            </div>
                                        </div>
                                    </div> */}

                                    <SliderAboutBookReview/> 



                                </div>
                            </div>













                                {/* book right side */}

                            <div className='book-court-right order-2 mx-4 md:w-[40%]'>
                                <div className='border border-gray-300 w-full h-auto rounded-2xl'>
                            <div>

                            <div className='w-[80%] mx-auto mt-6'>
                                <h3 className='text-[12px]  font-bold text-[#272C34] py-2'>Select court</h3>
                                <div className="  md:items-center mb-1">
                                            <div className='border border-gray-300 rounded-2xl pl-2 md:w-[100%]  py-2'>
                                                <select className=' outline-none text-gray-400 bg-[#FBFEFF]  w-[98%]'>
                                                    <option  >Select court Location</option>
                                                    <option>New York</option>
                                                    <option>Lahore</option>
                                                    <option>London</option>
                                                </select>
                                               
                                            </div>
                                        </div>
                            </div>

                                <center>


                                    <h1 className='text-gray-800 text-2xl font-bold py-10'>$ 67.90 <span className='text-gray-500 text-sm'>/game/player</span></h1>
                                    
                                </center>
                            </div>


                          {/* Book your seat right */}

                <div>
                    <div>
                    <div className='flex justify-between  '>
                    <h1 className=' font-bold text-base text-gray-600 px-6'>Book your seat</h1>
                    <div className='flex pr-4'>
                        <span className='rounded-full w-3 h-3 mt-1 bg-[#6A7D95] '></span> <h1 className=' px-2 text-[#6A7D95] font-bold text-[12px] '>Available</h1>
                    </div>
                    </div>
                    <h1 className='  text-[12px] text-[#6A7D95]  px-6'>Place 1 has been selected for booking.</h1>
                    </div>
                </div>


                
                <div className='w-full mt-2  px-2 '>
                    <div className='w-full border border-gray-300 rounded-xl h-[10rem]'>

                    <center>
                    <span className='h-[10rem]   bg-gray-500 border border-gray-300 absolute '></span>
                    </center>

                    <div className='border border-gray-300 reltive h-[5rem] w-[80%] mx-auto'>
                    <div className='flex px-6 mt-6 '>
                    <div className='h-7 w-7  p-1 pl-2 border-2 border-gray-300   rounded-full '>
                         <h1 className='text-xs '>1</h1>
                        </div>
                        <div className='h-7 w-7  p-1 pl-2 border-2 border-gray-300 rounded-full ml-32'>
                         <h1 className='  text-xs'>2</h1>
                        </div>
                    </div>

                    
                    </div>
                    
                    
                    <div className='border border-gray-300 h-[5rem] w-[80%] mx-auto'>
                    <div className='flex px-6 mt-6 justify-end'>
                    <div className='h-7 w-7 px-2 p-1 pl-2  border-2 border-gray-300  rounded-full bg-gray-50 mr-32'>
                         <h1 className=' text-xs'>3</h1>
                        </div>
                        <div className='h-7 w-7 px-2 p-1 pl-2 border-2 border-gray-300 rounded-full bg-gray-50'>
                         <h1 className=' text-xs'>4</h1>
                        </div>
                    </div>
                    </div>
                    
                    </div>
                </div>
  
                

                {/* No seats */}
                <div>
                <h1 className='text-[14px] pt-4 font-bold px-8 text-[#272C34]'>Games to book</h1>
                <p className='text-[#6A7D95] text-[12px] py-2 px-8 '>One game can be of maximum 1 hour.</p>
                <form class="  rounded  mb-4">
                <div class="mb-4 mx-8 flex">
 
                 <input class="shadow bg-[#FBFEFF]  appearance-none border border-gray-300 rounded-xl w-full  h-[32px] px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="username" type="text" placeholder='0' />
                 <div className='flex h-[31px] bg-gray-200   rounded-r-xl -ml-[83px]'>
                  
                  <button className='bg-[#ecf1f4]'> <i class=" fa-solid fa-minus text-xl px-3 active:text-blue-300"></i></button> <button className='  text-xl bg-[#ecf1f4] rounded-r-xl'><i class=" fa-solid fa-plus px-3 active:text-blue-300"></i></button>
                  </div>
                 </div>
                  </form>
                </div>

                 {/* Select date */}
                 <div>
                <h1 className=' py-4 px-8 text-[12px] font-bold text-[#272C34]   '>Select date</h1>
                <form class="  rounded  mb-4">
                <div class="mb-4 mx-8 flex ">
 
                 <input class="shadow bg-[#FBFEFF]  border border-gray-300 appearance-none border text-gray-600 rounded-xl w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="username" type="date" />
 
                 </div>
                  </form>
                </div>

                {/* select time slot */}

                  
                  <div className='charge   mb-4  mx-8  my-2 p-5'>
                            <div>
                                <h2 className='text-[12px] font-bold text-[#272C34]  '>Select Availabe time slot</h2>
                            </div>
                            <div>

                                <form className='my-3'>

                                    <div className="  md:items-center mb-1">
                                        <label className="md:w-2/3 block text-gray-500 font-bold">
                                            <input className="mr-2 h-[15px] w-[15px] leading-tight" type="checkbox" />
                                            <span className="text-[12px] text-[#6A7D95]">
                                               11 : 00 AM - 12 : 00 PM
                                            </span>
                                        </label>
                                    </div>

                                    <div className="  md:items-center mb-1">
                                        <label className="md:w-2/3 block text-gray-500 font-bold">
                                            <input className="mr-2 h-[15px] w-[15px] leading-tight" type="checkbox" />
                                            <span className="text-[12px] text-[#6A7D95]">
                                            11 : 00 AM - 12 : 00 PM
                                            </span>
                                        </label>
                                    </div>

                                    <div className="  md:items-center mb-1">
                                        <label className="md:w-2/3 block text-gray-500 font-bold">
                                            <input className="mr-2 h-[15px] w-[15px] leading-tight" type="checkbox" />
                                            <span className="text-[12px]   text-[#6A7D95]">
                                            11 : 00 AM - 12 : 00 PM
                                            </span>
                                        </label>
                                    </div>

                                </form>
                            </div>
                        </div>

                        {/* book now model button  */}
                        <div>
                            <div>
                        
                     <Modal/> 

                            </div>
                        </div>

                
                    </div>




  {/* links div start */}
  <div className='charge border my-7 border-gray-300 rounded-xl mx-2 '>

           <div className='flex justify-between py-5  border-b border-gray-300'> 
               <h2 className='text-[12px] cursor-pointer text-[#009FD9] font-bold pl-4  '>https//:padelcompany.com/</h2>
               <i class="fa-solid fa-diamond-turn-right h-[16px] w-[16px] pr-8   text-[#009FD9]"></i>
            </div>
            <div className='flex justify-between py-5 border border-b-gray-300'> 
               <h2 className='text-[12px] cursor-pointer text-[#009FD9] font-bold pl-4  '>https//:padelcompany.com/</h2>
               <i class="fa-solid fa-arrow-up-right-from-square h-[16px] w-[16px] pr-8   text-[#009FD9]"></i>
            </div>
            <div className='flex justify-between py-5 border border-b-gray-300'> 
               <h2 className='text-[12px] cursor-pointer text-[#009FD9] font-bold pl-4  '>https//:padelcompany.com/</h2>
               <i class="fa-solid fa-envelope h-[16px] w-[16px] pr-8   text-[#009FD9]"></i>
            </div>
            <div className='flex justify-between py-5 border-t border-gray-300'>  
               <h2 className='text-[12px] cursor-pointer text-[#009FD9] font-bold pl-4  '>https//:padelcompany.com/</h2>
               <i class="fa-solid fa-phone h-[16px] w-[16px] pr-8   text-[#009FD9]"></i>
            </div>
            

                            <div>

                                
                            </div>
   </div>


                        {/* Links div end */}




                            </div>



                        </div>
                    </div>

     </>
  )
}

export default AboutComp